/**
 * Role-based permission helper.
 * Reads orgRole from localStorage (set at login time).
 *
 * Roles: ORG_ADMIN, MEMBER, AUDITOR, VIEWER, CISO_RESELLER, CPA_AUDITOR, CPA_ADMIN
 */

export function getOrgPermissions() {
  const orgRole        = localStorage.getItem('orgRole') || 'MEMBER';
  const isPlatformAdmin = localStorage.getItem('role') === 'ROLE_PLATFORM_ADMIN';
  const isOrgAdmin     = orgRole === 'ORG_ADMIN' || isPlatformAdmin;
  // Partner roles (CPA admin/auditor, CISO reseller) manage CLIENT orgs from their
  // own portal — when they open a client's workspace they need full org_admin-
  // level capabilities scoped to that client. Treat them as elevated for the
  // capability checks below.
  const isPartner      = orgRole === 'CPA_ADMIN' || orgRole === 'CPA_AUDITOR' || orgRole === 'CISO_RESELLER';

  return {
    isOrgAdmin,
    isPlatformAdmin,
    isPartner,
    orgRole,

    // Specific capabilities
    canManageFrameworks:      isOrgAdmin || isPartner,
    canManageUsers:           isOrgAdmin || isPartner,
    canManageBilling:         isOrgAdmin || isPartner,
    canCreateAudit:           isOrgAdmin || isPartner || orgRole === 'AUDITOR',
    canManageTrustCenter:     isOrgAdmin || isPartner,
    canScanDomains:           isOrgAdmin || isPartner,
    canConfigureIntegrations: isOrgAdmin || isPartner,
    canManageVendors:         isOrgAdmin || isPartner,
    canViewOnly:              orgRole === 'VIEWER',
    // Org self-service Red Team Planning (/api/red-team/self/*) — mirrors the backend's
    // requireOrgSelfServiceEligible(): an org's own admin, but NOT a partner-managed org (a
    // reseller's clients keep using the existing partner-credit flow under /dashboard/red-team
    // instead, which PartnerRedTeam.js already serves to isPartner).
    canUseRedTeamPlanning:    isOrgAdmin && !isPartner,
  };
}
